import { Component, OnInit, inject } from '@angular/core';
import { StudentInfo, SearchStudentRequest, StudentService} from '../../lib';
import { ToastService } from '../toast/toast.service';

@Component({
  selector: 'app-student-search',
  templateUrl: './student-search.component.html'
})
export class StudentSearchComponent  implements OnInit {
  searchFilter: string | undefined;
	toastService = inject(ToastService);
  public students: StudentInfo[] | undefined;
  public search: SearchStudentRequest = { phoneNumber: undefined,syStudentId:undefined}
  constructor(private studentService: StudentService) {
  }
  ngOnInit(): void {
    this.searchFilter = 'Id';
  }

  change(filter: string) {
    if(filter == 'Id') {
      this.search.phoneNumber = undefined
    }
    if(filter == 'Phone') {
      this.search.syStudentId = undefined
    }
  }

  getStudents() {
    let req : any = {}
    if(this.search.syStudentId) {
      req.syStudentId = `${this.search.syStudentId}`
    }
    if(this.search.phoneNumber) {
      req.phoneNumber = `${this.search.phoneNumber}`
    }
    this.studentService.apiStudentPost(req).subscribe({
      next: (response) => {
        this.students = response;
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

}
